<template>
  <vx-card>
    <div class="privacy-layout">
      <!-- header -->
      <div class="privacy-layout-header flex justify-between items-center ">
        <h3>{{ title }}</h3>
        <label class="p-2 flex justify-center items-center">
          <feather-icon icon="XIcon" class="cursor-pointer" @click="onClickClose" />
        </label>
      </div>

      <!-- body -->
      <div class="privacy-layout-body">
        <slot />
      </div>

      <!-- footer -->
      <div class="privacy-layout-footer flex justify-end items-center ">
        <vs-button color="#AEB1B6" @click="onClickPrev">이전</vs-button>
        <vs-button color="secondary" @click="onClickNext">다음</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  name: "RegisterLayout",
  props: {
    title: String,
  },
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    onClickPrev() {
      this.$emit('prev');
    },
    onClickNext() {
      this.$emit('next');
    }
  }
}
</script>

<style scoped lang="scss">
vx-card::v-deep{
  .vx-card__body {
    padding: 0;
  }
}
.privacy-layout {
  background-color: #ffffff;
}
.privacy-layout-header,
.privacy-layout-body,
.privacy-layout-footer {
  margin: 0 10px 20px;
}
.privacy-layout-header {
  padding: 12px 0;

  color: #222222;
  font-size: 18px;
  font-width: bold;

  border-bottom: 1px solid #cdcdcd;
}
.privacy-layout-footer {
  margin-bottom: 0;
  gap: 1rem;
}
</style>
